var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { ApiRoutePlurality, HTTP_METHOD } from '../../../../../defs/schema-static';
import { COGNITO_SCHEMA_ROUTE } from '../../../../../defs/schema/public/Cognito';
import { HttpRestService } from '../../shared/http-rest/http-rest.service';
var EmployeeWizardGroupRightsComponent = (function () {
    function EmployeeWizardGroupRightsComponent(httpRest) {
        this.httpRest = httpRest;
        this.selectedGroups = [];
    }
    EmployeeWizardGroupRightsComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.groups) {
            (function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2, this.getGroups()];
            }); }); })();
        }
    };
    EmployeeWizardGroupRightsComponent.prototype.getGroups = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this.httpRest
                                ._request(HTTP_METHOD.GET, ApiRoutePlurality.SINGULAR, COGNITO_SCHEMA_ROUTE, 'groups')
                                .toPromise()];
                    case 1:
                        _a.groups = _b.sent();
                        return [2];
                }
            });
        });
    };
    EmployeeWizardGroupRightsComponent.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.employee || !this.employee.user || !this.employee.user.cognitoUsername) {
                    throw new Error("missing employee cognitoUsername, can't submit");
                }
                if (!this.selectedGroups || !this.selectedGroups.length) {
                    return [2, undefined];
                }
                return [2, Promise.all((this.selectedGroups || []).map(function (_a) {
                        var groupName = _a.groupName;
                        return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_b) {
                                return [2, this.httpRest
                                        ._request(HTTP_METHOD.PUT, ApiRoutePlurality.SINGULAR, COGNITO_SCHEMA_ROUTE, 'user', {
                                        username: this.employee.user.cognitoUsername,
                                        groupName: groupName,
                                    })
                                        .toPromise()];
                            });
                        });
                    }))];
            });
        });
    };
    EmployeeWizardGroupRightsComponent.prototype.reset = function () {
        this.selectedGroups = [];
    };
    return EmployeeWizardGroupRightsComponent;
}());
export { EmployeeWizardGroupRightsComponent };
